import {vpost} from "@/util/post";

export const complaint = {
    /**
     * 获取投诉列表
     * @param id
     * @param type
     * @param keyword
     * @param createBy
     * @param miuUserId
     * @param pageCurrent
     * @param pageSize
     * @returns {Promise}
     */
    list({
             id,
             type,
             keyword,
             createBy,
             miuUserId,
             pageCurrent,
             pageSize
         } = {}) { // 设置默认值为空对象

        console.log("list");
        const query = {
            id,
            type,
            keyword,
            createBy,
            miuUserId,
            pageCurrent,
            pageSize
        }; // 手动组装 query
        console.log(query);

        return vpost("/miu/complaint/query", query);
    },

    detail(id) {
        return vpost("/miu/complaint/getMiuComplaint?id=" + id);
    },
}
